import styled from '@emotion/styled';

export const FormButtonContainer = styled('div')({
  marginRight: 0,
  display: 'flex',
  justifyContent: 'flex-end',
});
